<template>
  <div class="customLogin"></div>
</template>
<script>
import { req_userInfo } from "@/services/user";

export default {
  name: "customLogin",
  components: {},
  data() {
    return {};
  },
  methods: {
    async func_customLogin(userid, worker) {
      this.$parent.loadingChange(true, "自定义登录中");
      const result = await req_userInfo(userid);
      this.$parent.loadingChange(false);
      if (result.success) {
        this.$parent.msgChange("success", "登录成功", "", 3000);
        // 1) 清除该清除的
        this.STORAGE.remove("g_userInfo");
        this.STORAGE.remove("g_trollerList");

        // 2) 调用全局登录流程
        this.$parent.func_appLoginwithworker(result.data, worker);
        if (this.$parent.isorder) {
          this.$router.push({
            name: "home",
          });
        } else {
          this.$router.push({
            name: "order",
          });
        }
      } else {
        this.$parent.msgChange("fail", result.msg, "", 3000);
      }
    },
  },
  mounted() {
    const params = this.$route.params;
    let worker = "";
    if (params.f) {
      worker = params.f;
    }
    if (params && params.constructor["name"] === "Object" && params["userid"]) {
      this.func_customLogin(params["userid"], worker);
    }
  },
  destroyed() {},
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/pages/CustomLogin.vue